export default class Unravel {
  constructor() {
    const container = document.querySelectorAll(".unworkshop")

    if (container.length > 0) {
      container.forEach((el) => {
        const video = el.querySelector("video")
        if (video) {
          video.play()
          video.pause()

          window.addEventListener("scroll", () => {
            const rect = video.getBoundingClientRect()
            if (rect.top < window.innerHeight && rect.bottom > 0) {
              const inViewProgress = (rect.top + rect.height) / (window.innerHeight + rect.height)
              video.currentTime = video.duration * inViewProgress
            }
          })
        }
      })
    }
  }
}
